import {Platform, Text} from 'react-native';
import styled from 'styled-components';

const style = {
  marginTop: 5,
  marginRight: 10,
  fontFamily: 'IRANSans',
  fontWeight: 600,
};

const SubInputText =
  Platform.OS === 'android' || Platform.OS === 'ios'
    ? styled(Text)`
        ${style}
        font-size: 14px;
        color: ${({theme}) => theme.colors.text.base};
      `
    : styled.span`
        ${style}
        font-size: 11px;
        color: ${({theme}) => theme.colors.text.base};
      `;

export default SubInputText;
